import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, memo } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    IconButton,
    ButtonGroup,
    Tooltip,
    Chip,
    Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { Info } from '@mui/icons-material';

import { myTimestampToDate } from '../utils/ui_utils';
import { useEvent } from '../context/eventContext';
import { differenceInMonths, format } from 'date-fns';
import { globalstyles } from '../lib/definitions';
import { PropertyButton } from '../definitions/property';
import { MyCloseBtn } from '../components/MyButtons';
import { PublicCowDialog } from './PublicCowDialog';



export const newmatch = {
    match_name: '',
    match_description: '',
    match_type: 'normal',
    cow_list: [],
    award_list: [],
    has_partial: false,
    planned_start: new Date()
}






export const AwardListDialog = forwardRef(({ }, ref) => {
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newmatch })
    const [cur_award, setCurAward] = useState(0)
    const publicRef = useRef()

    const [award_result_list, setAwardResultList] = useState([])

    useImperativeHandle(ref, () => {
        return {
            onEdit(el, i) {
                setOpen(true);
                let _el = { ...newmatch, ...el }
                setCurElement(_el)
                setCurAward(0)
                initSublist(_el)
            }
        }
    })


    const handleClose = () => {
        setOpen(false);
    };


    const initSublist = (el) => {
        let filtered_list = []
        if (el.result_list) {
            for (const a of el.result_list) {
                if (a.filter_data_list && a.filter_data_list.length>0) {
                    for (const f of a.filter_data_list.sort()) {
                        if (f === 'all') {
                            filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified), has_position: a.has_position, id: a.id, name: a.award_name, subname: 'tutti', show_not_classified: a.has_position })
                        } else if (f === 'red') {
                            filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified).filter(c => c.cow.cow_type === 'red'), has_position: a.has_position, id: a.id, name: a.award_name, subname: 'red', show_not_classified: false })
                        } else if (f === 'black') {
                            filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified).filter(c => c.cow.cow_type === 'black'), has_position: a.has_position, id: a.id, name: a.award_name, subname: 'black', show_not_classified: false })
                        }else{
                            filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified).filter(c => c.cow[f] === true), has_position: a.has_position, id: a.id, name: a.award_name, subname: f, show_not_classified: false })
                        }
                    }
                } else {
                    filtered_list.push({ cow_list: a.cow_list, show_not_classified: a.has_position,has_position: a.has_position, id: a.id, name: a.award_name })
                }

            }
        }
        console.log("FILTERED LIST", filtered_list)
        setAwardResultList(filtered_list)
    }

    const handleShow = (c) => {
        publicRef.current.onShow(c)
    }


    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="md" fullScreen={true}>
                <PublicCowDialog ref={publicRef} />
                <DialogTitle>
                    <Grid container>
                        <Grid size="grow">
                            Risultati gara: &nbsp;
                            <b>{curElement.match_name}</b>
                        </Grid>
                        <Grid size="auto" sx={{ textAlign: "right" }}>
                            <Typography sx={{ fontSize: '0.5em' }}>
                                premi assegnati in questa gara
                            </Typography>
                            <ButtonGroup color="secondary" size="small">
                                {award_result_list.map((a, k) => (
                                    <Button variant={cur_award === k ? 'contained' : 'outlined'} onClick={() => setCurAward(k)}>{a.subname || a.name} {a.has_position && <>({a.cow_list?.length} soggetti)</>}</Button>
                                ))}
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                    {award_result_list.length > 0 &&
                        <Grid container sx={globalstyles.listHeader}>
                            <Grid size={0.5}>
                                Pos
                            </Grid>
                            <Grid size={0.5}>
                                Catalogo
                            </Grid>
                            <Grid size={1} flexDirection={"row"} container>
                                Matricola
                            </Grid>
                            <Grid size={"grow"}>
                                Nome
                            </Grid>
                            <Grid size={"grow"}>
                                Proprietà
                            </Grid>
                            <Grid size={1}>
                                parti
                            </Grid>
                            <Grid size={1}>
                                Età (mesi)
                            </Grid>
                            <Grid size={1}>
                                Data di nascita
                            </Grid>
                            <Grid size={0.5}>
                            </Grid>
                        </Grid>
                    }
                </DialogTitle>
                <DialogContent>
                    {award_result_list.length > 0 ?
                        <>
                            {award_result_list[cur_award] && award_result_list[cur_award].cow_list.length === 0 &&
                            <>
                            nessun soggetto classificato
                            </>
                            }
                            {award_result_list[cur_award] && award_result_list[cur_award].cow_list?.map((cow, k) => (
                                <OneCow cow={cow.cow} key={k} index={k} handleShow={handleShow} />
                            ))}

                            {award_result_list[cur_award] && award_result_list[cur_award].show_not_classified &&
                                <NotMatchCows match_cow_list={award_result_list[cur_award] && award_result_list[cur_award].cow_list ? award_result_list[cur_award].cow_list : undefined} cow_list={curElement.cow_list} handleShow={handleShow}/>
                            }

                        </>
                        :
                        <>
                            nessun risultato presente
                        </>
                    }
                </DialogContent>
                <DialogActions>
                    <MyCloseBtn handleClose={handleClose} />
                </DialogActions>
            </Dialog>
        </div>
    );
})


const NotMatchCows = ({ match_cow_list, cow_list, handleShow }) => {
    const c_list = match_cow_list.map(c => c.cow?.id).filter(c => c !== undefined)
    const e_c_list = cow_list.filter(c => !c_list.includes(c.id))
    if (e_c_list.length > 0) {

        return (
            <>
                Soggetti non classificati <Chip label={e_c_list.length} size="small" />
                <Grid container sx={globalstyles.listHeader}>
                    <Grid size={0.5}>

                    </Grid>
                    <Grid size={0.5}>
                        Catalogo
                    </Grid>
                    <Grid size={1} flexDirection={"row"} container>
                        Matricola
                    </Grid>
                    <Grid size={"grow"}>
                        Nome
                    </Grid>
                    <Grid size={"grow"}>
                        Proprietà
                    </Grid>
                    <Grid size={1}>
                        parti
                    </Grid>
                    <Grid size={1}>
                        Età (mesi)
                    </Grid>
                    <Grid size={1}>
                        Data di nascita
                    </Grid>
                    <Grid size={0.5}>
                    </Grid>
                </Grid>
                {e_c_list.map((cow, k) => (
                    <OneCow cow={cow} key={k} handleShow={handleShow}/>
                ))}

            </>
        )
    }
}





const OneCow = memo(({ cow, index, handleShow }) => {
    const { selEvent } = useEvent()
    if (cow && cow.id) {

        const birthdate = myTimestampToDate(cow.birthdate)
        const ev_date = myTimestampToDate(selEvent.event_start)

        return (
            <Grid container sx={{ ...globalstyles.list_row, fontSize: '0.7em' }}>
                <Grid size={0.5}>
                    {index !== undefined&&
                        <Chip size="small" label={index + 1} />
                    }
                </Grid>
                <Grid size={0.5}>
                    {cow.catalog_id}
                </Grid>
                <Grid size={1} flexDirection={"row"} container>
                    {cow.cow_type === 'red' ?
                        <Tooltip placement="right" title="red">
                            <Box sx={{ backgroundColor: 'red', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                        </Tooltip>
                        :
                        <Tooltip placement="right" title="black">
                            <Box sx={{ backgroundColor: 'black', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                        </Tooltip>
                    }
                    {cow.serial}
                </Grid>
                <Grid size="grow">
                    {cow.name}
                </Grid>
                <Grid size="grow">
                    {cow.property &&
                        <PropertyButton element={cow.property} />
                    }
                </Grid>
                <Grid size={1}>
                    {cow.birth}
                </Grid>
                <Grid size={1}>
                    {differenceInMonths(ev_date, birthdate)}
                </Grid>
                <Grid size={1}>
                    {format(birthdate, 'dd/MM/yyyy')}
                </Grid>
                <Grid fontSize={0.5}>
                    <IconButton size="small" color="primary" variant="outlined" onClick={() => handleShow(cow)}><Info sx={{ fontSize: '1.2em' }} /></IconButton>
                </Grid>
            </Grid>
        )

    } else {
        return <></>

    }
})
